import { useState, useRef, useCallback } from 'react';

export const useDraggable = (initialPos = { x: 20, y: 20 }) => {
    const [position, setPosition] = useState(initialPos);
    const isDragging = useRef(false);
    const offset = useRef({ x: 0, y: 0 });
    const dragHandleRef = useRef(null);

    const onMouseDown = useCallback((e) => {
        // Only drag if clicking the handle itself
        if (!dragHandleRef.current?.contains(e.target)) return;

        e.preventDefault();
        isDragging.current = true;
        offset.current = {
            x: e.clientX - position.x,
            y: e.clientY - position.y
        };

        const onMouseMove = (e) => {
            if (!isDragging.current) return;
            setPosition({
                x: Math.max(0, Math.min(window.innerWidth - 320, e.clientX - offset.current.x)),
                y: Math.max(0, Math.min(window.innerHeight - 200, e.clientY - offset.current.y))
            });
        };

        const onMouseUp = () => {
            isDragging.current = false;
            window.removeEventListener('mousemove', onMouseMove);
            window.removeEventListener('mouseup', onMouseUp);
        };

        window.addEventListener('mousemove', onMouseMove);
        window.addEventListener('mouseup', onMouseUp);
    }, [position]);

    return { position, onMouseDown, dragHandleRef };
};